import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=149b5981&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=149b5981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b5981",
  null
  
)

export default component.exports